import SvgIcon from '@/components/SvgIcon';
import { PageEnum, MONTH_FORMAT } from '@/enums/pageEnum';
import { MenuPath } from '@/facilities/model/user';
import dayjs from '@/utils/dayjsConfig';

/** Demo build: only these sidebar entries are shown (order = sidebar order, first one is the landing page).
 *  Routes stay registered, so deep links to other pages still work. Empty list = show everything. */
export const VISIBLE_MENUS: string[] = [];
export const isVisibleMenu = (name?: string) =>
  !VISIBLE_MENUS.length || !name || VISIBLE_MENUS.includes(name);

const curDate = new Date();
const previousMonth = new Date(curDate.getFullYear(), curDate.getMonth() - 1, 1);

export const reportMenus = [
  {
    path: '/report/mcr',
    name: 'report.mcr',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/mar',
    name: 'report.mar',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/plr',
    name: 'report.plr',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/mptr',
    name: 'report.mptr',
    filePath: 'report/monthly-passenger-trap',
    defaultParams: { month: dayjs(previousMonth).format(MONTH_FORMAT) },
  },
  {
    path: '/report/dbr',
    name: 'report.dbr',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/mbr',
    name: 'report.mbr',
    filePath: 'report/monthly-breakdown',
    defaultParams: { month: dayjs(previousMonth).format(MONTH_FORMAT) },
  },
  {
    path: '/report/breakdown-code-summary-report',
    name: 'report.breakdown_code_summary_report',
    filePath: 'report/breakdown-code-summary',
    defaultParams: { month: dayjs(previousMonth).format(MONTH_FORMAT) },
  },
  {
    path: '/report/dcr',
    name: 'report.dcr',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/tcmr_tcmr',
    name: 'report.tcmr_tcmr',
    filePath: 'report/tcmr',
    defaultParams: { month: dayjs(previousMonth).format(MONTH_FORMAT) },
  },
  {
    path: '/report/w_lm_r',
    name: 'report.w_lm_r',
    filePath: 'report/monthly-complaint',
  },
  {
    path: '/report/clr',
    name: 'report.clr',
    filePath: 'report/chronic-lifts',
  },
];

export const defaultMenus = [
  {
    path: '/home',
    name: 'home',
    filePath: 'home',
    icon: <SvgIcon classa="home" />,
  },
  {
    path: '/alarms',
    name: 'alarms',
    filePath: 'navigateRedirect',
    icon: <SvgIcon classa="alarms" />,
    routes: [
      {
        path: PageEnum.ALARMLF,
        name: 'alarms.lift_fault',
        filePath: 'lift-fault',
        child: [
          {
            path: `${PageEnum.ALARMLF}/detail/:id`,
            name: 'liftFauDetail',
            filePath: 'lift-fault/detail',
          },
        ],
      },
      {
        path: PageEnum.ALARMPT,
        name: 'alarms.passenger_trap',
        filePath: 'passenger-trap',
        child: [
          {
            path: `${PageEnum.ALARMPT}/detail/:id`,
            name: 'passengerTrapDetail',
            filePath: 'passenger-trap/detail',
          },
        ],
      },
      { path: PageEnum.ALARMRBE, name: 'alarms.rbe', filePath: 'RBE' },
    ],
  },
  {
    path: PageEnum.LIFT,
    name: 'lifts',
    filePath: 'lift',
    icon: <SvgIcon classa="lift" />,
    child: [
      {
        path: `${PageEnum.LIFT}/detail/:id`,
        name: 'detail',
        filePath: 'lift/detail',
      },
    ],
  },
  {
    path: PageEnum.BUILDING,
    name: 'building',
    filePath: 'building',
    icon: <SvgIcon classa="building" />,
    child: [
      {
        path: `${PageEnum.BUILDING}/detail/:id`,
        name: 'detail',
        filePath: 'building/detail',
      },
    ],
  },
  {
    path: '/lmd',
    name: 'lmd',
    filePath: 'lmd',
    icon: <SvgIcon classa="lmd" />,
    child: [
      {
        path: `${PageEnum.LMD}/detail/:id`,
        name: 'detail',
        filePath: 'lmd/detail',
      },
    ],
  },
  {
    path: '/lm-schedule',
    name: 'lm_schedule',
    filePath: 'lm-schedule',
    defaultParams: { month: dayjs(curDate).format(MONTH_FORMAT) },
    icon: <SvgIcon classa="lm" />,
  },
  {
    path: '/lm-checker',
    name: 'lm_checker',
    filePath: 'lm-checker',
    icon: <SvgIcon classa="check" />,
    defaultParams: { month: dayjs(curDate).format(MONTH_FORMAT) },
  },
  {
    path: PageEnum.OMS_SCHEDULE,
    name: 'oms_schedule',
    filePath: 'oms-schedule',
    icon: <SvgIcon classa="mach" />,
    child: [
      {
        path: `${PageEnum.OMS_SCHEDULE}/detail/:id`,
        name: 'detail',
        filePath: 'oms-schedule/detail',
      },
      {
        path: `${PageEnum.OMS_SCHEDULE}/add-new`,
        name: 'oms_schedule',
        filePath: 'oms-schedule/add-new',
      },
    ],
  },
  {
    path: PageEnum.AI_HOTLINE,
    name: 'ai_hotline',
    filePath: 'ai-hotline',
    icon: <SvgIcon classa="hotline" />,
  },
  {
    path: '/case-management',
    name: 'case_management',
    filePath: 'case-management',
    icon: <SvgIcon classa="case" />,
    child: [
      {
        path: `${PageEnum.CASE_MANAGDETAL}/:id`,
        name: 'detail',
        filePath: 'case-management/detail',
      },
      {
        path: PageEnum.CASE_MANAGDEADD,
        name: 'case_management',
        filePath: 'case-management/detail',
      },
      {
        path: `${PageEnum.CASE_MANAGDEDETAL}/:id`,
        name: 'case_management',
        filePath: 'case-management/detail',
      },
    ],
  },
  {
    path: '/report',
    name: 'report',
    filePath: 'navigateRedirect',
    icon: <SvgIcon classa="report" />,
    routes: reportMenus,
  },
];

const menu: MenuPath = {
  path: '/',
  routes: [
    ...defaultMenus,
    {
      path: PageEnum.ORGANIZATION,
      name: 'organization',
      filePath: 'organization',
      icon: <SvgIcon classa="organ" />,
      child: [
        {
          path: `${PageEnum.USERMANGMENTDETAL}/:id`,
          name: 'detail',
          filePath: 'organization/detail',
        },
        {
          path: PageEnum.TYPESETTING,
          name: 'typeSetting',
          filePath: 'organization/type-setting',
        },
        {
          path: `${PageEnum.TYPESETTING}/detail/:id`,
          name: 'typeDetail',
          filePath: 'organization/type-detail',
        },
      ],
    },
    {
      path: PageEnum.USERMANGMENT,
      name: 'user_management',
      filePath: 'navigateRedirect',
      icon: <SvgIcon classa="user" />,
      routes: [
        {
          path: '/user-management/user',
          name: 'user',
          filePath: 'user',
        },
        {
          path: PageEnum.USRTGROUP,
          name: 'group',
          filePath: 'group',
          child: [
            {
              path: `${PageEnum.USRTGROUP}/detail/:id`,
              name: 'groupDetail',
              filePath: 'group/detail',
            },
          ],
        },
      ],
    },
    {
      path: '/settings',
      name: 'settings',
      filePath: 'settings',
      icon: <SvgIcon classa="settings" />,
    },
  ],
};

export default menu;
